"use client";
import { ContactCiruclarButton } from "@/components/common/Buttons/ContactCiruclarButton/ContactCiruclarButton";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";
import { useContact } from "@/provider/ContextForm";
import { useDeviceDetector } from "@/utils/useDeviceDetector";
import gsap from "gsap";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Wave from "react-wavify";
import style from "./WhyChooseUs.module.scss";

interface WhyChooseUsProps {
  messages?: any;
}

export const WhyChooseUs = ({ messages }: WhyChooseUsProps) => {
  const whyChooseUsRef = useRef(null);
  const { setIsContactOpen } = useContact();
  const buttonRef = useRef(null);
  const { isMobile } = useDeviceDetector();

  useLayoutEffect(() => {
    let ctx;

    if (isMobile !== null) {
      ctx = gsap.context(() => {
        if (buttonRef.current && whyChooseUsRef.current) {
          gsap.to(buttonRef.current, {
            bottom: isMobile ? "10%" : "15%",
            duration: 1,
            ease: "power3.out",
            delay: 0,
            scrollTrigger: {
              trigger: whyChooseUsRef.current,
              start: "top top",
              end: "top top",
            },
          });
        }
      });
    }

    return () => ctx?.revert();
  }, [isMobile]);
  return (
    <section className={style.whyChooseUsWrap} ref={whyChooseUsRef}>
      <div className="container">
        <TitleAnimation
          messages={{
            first_word: messages?.first_words,
            second_word: messages?.second_words,
          }}
        />
        <p className={style.description}>{messages?.description}</p>
        <div
          ref={buttonRef}
          className={style.buttonContainer}
          onClick={() => setIsContactOpen(true)}
        >
          <ContactCiruclarButton />
        </div>
      </div>
    </section>
  );
};
